export default __webpack_public_path__ + "static/media/10.ec4a9d9d.jpg";